import styled, { keyframes } from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 0.8rem;
  border-radius: 0.4rem;
  background: #e1dfdf;
  /* Add inner shadow */
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  position: relative;
`;

const progressAnimation = (width) => keyframes`
  0% {
    width: 0%;
  }
  100% {
    width: ${width};
  }
`;

function darkenColor(color, percent) {
  const num = parseInt(color.replace("#", ""), 16),
    amt = Math.round(2.55 * percent),
    R = Math.max(Math.min((num >> 16) - amt, 255), 0),
    G = Math.max(Math.min(((num >> 8) & 0x00ff) - amt, 255), 0),
    B = Math.max(Math.min((num & 0x0000ff) - amt, 255), 0);
  return (
    "#" +
    ((1 << 24) | (R << 16) | (G << 8) | B).toString(16).slice(1).toUpperCase()
  );
}

function lightenColor(color, percent) {
  const num = parseInt(color.replace("#", ""), 16),
    amt = Math.round(2.55 * percent),
    R = Math.max(Math.min((num >> 16) + amt, 255), 0),
    G = Math.max(Math.min(((num >> 8) & 0x00ff) + amt, 255), 0),
    B = Math.max(Math.min((num & 0x0000ff) + amt, 255), 0);
  return (
    "#" +
    ((1 << 24) | (R << 16) | (G << 8) | B).toString(16).slice(1).toUpperCase()
  );
}

export const ProgressMeter = styled.div`
  height: 0.8rem;
  border-radius: 0.4rem;
  /* Gradient for light effect */
  background: linear-gradient(
    to top,
    ${(props) => darkenColor(props.color, 15)} 0%,
    ${(props) => lightenColor(props.color, 15)} 70%,
    ${(props) => darkenColor(props.color, 15)} 100%
  );
  /* Animation */
  animation: ${(props) => progressAnimation(props.width)} 2s forwards;
  z-index: 1;
`;

export const PBNumber = styled.span`
  position: absolute;
  top: calc(50% + 1px);
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;

  font-weight: 400;
  font-size: 0.76rem;
  line-height: 0.8rem;
  z-index: 5;
  color: #000;
`;
